import { TitleWithDivider } from "@common/TitleWithDivider";
import { SearchBar } from "@components/SearchBar/SearchBarTemplate";
import { HeaderItems } from "@common/HeaderItems";
import LoadingIcon from "@common/LoadingIcon";
import FilterModal from "@components/Modals/FilterSelectModal";
import PaginationControls from "@services/PaginationControls";
import TenantsTable from "@components/Tables/TenantTable";
import pageHeaders from "@constants/PageHeaders";
import { useTenantAdminPage } from "@pages/Tenant/TenantAdminPage/hooks/UseTenantAdminPage";

const TenantAdminPage: React.FC = () => {
  const form = useTenantAdminPage();

  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.TENANT.main}
          useDivider={true}
        />
        <SearchBar
          onSearch={form.onSearch}
          onFilterSearch={form.onFilteredSearch}
          searchBarText={"テナント検索キーワード"}
          buttonLeft={"検索"}
          buttonRight={"絞込検索"}
          setSearchTerm={form.setSearchTerm}
        ></SearchBar>
        <div className="flex justify-between">
          <HeaderItems
            items={form.headerItems}
            topPadding={5}
            useDivider={false}
          ></HeaderItems>
          <div className="mt-5 flex flex-center justify-end items-center">{`総テナント数: ${form.totalTenants}企業`}</div>
        </div>
        <div className="mb-5"></div>
        {form.loading ? (
          <LoadingIcon />
        ) : (
          <>
            <TenantsTable
              onTenantSelect={form.handleTenantSelect}
              onDeselectAll={form.handleDeselectAll}
              tenantInformation={form.tenantData}
              allSelected={form.allSelected}
              loading={form.loading}
              setAllSelected={form.setAllSelected}
            />
            <PaginationControls
              currentPage={form.currentPage}
              totalPages={form.totalPages}
              totalItems={form.totalTenants}
              displayedItem={"企業"}
              onPageChange={form.handlePageChange}
              setPerPage={form.setItemsPerPage}
              perPage={form.itemsPerPage}
            />
          </>
        )}
        {/* <WarningModal
          title={warningModalTitle}
          body={warningModalBody}
          confirmText={warningModalConfirm}
          isOpen={deleteModalOpen}
          onConfirm={delete}
          onRequestClose={closeDeleteModal}
        ></WarningModal> */}
        <FilterModal
          type={"tenant"}
          isOpen={form.filterModalOpen}
          onRequestClose={form.onFilteredModalClose}
          onApplyFilters={form.doFilteredSearch}
          filters={form.filters}
        ></FilterModal>
      </div>
    </>
  );
};

export default TenantAdminPage;
